const UNRESOLVED_ZIP_CODES = new Set(['00000', '00000-0000'])

/**
 * Returns a canonical 5-digit US ZIP, or "" when the input is not a usable ZIP.
 *
 * The zip input fires `onZipChange` on every keystroke, so a partial value like
 * `8` used to be persisted to sessionStorage and then read back to forward
 * `zip=8` to the results page (which then hung geocoding an invalid ZIP). We now
 * require exactly 5 digits: non-digits are stripped, ZIP+4 keeps its 5-digit
 * prefix, and the all-zero sentinels are rejected. Anything else returns "".
 */
export function getUsableZipCode(zipCode?: string | null): string {
  const digits = (zipCode ?? '').replace(/\D/g, '')
  if (digits.length < 5) return ''

  const zip5 = digits.slice(0, 5)
  if (UNRESOLVED_ZIP_CODES.has(zip5)) return ''

  return zip5
}
